<div *ngIf="isVisible" @showHideTrigger>
    <div class="modal">
        <div class="modal-body">
            @if(!isHideHeader)
            {
                <div class="modal-header">
                    <ng-content select="[modal-title]"></ng-content>

                    <button (click)="closeModal()">
                        <img src="/assets/images/quick-actions/close.svg" alt="close">
                    </button>
                </div>
            }
            <ng-content select="[modal-body]"></ng-content>
        </div>
    </div>
</div>
